var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOldPlay = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512",
  "aria-labelledby": titleId,
  fill: "currentColor"
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M424.4 214.7 72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"
})));
export { SvgOldPlay as ReactComponent };
export default __webpack_public_path__ + "assets/images/old-play.svg";